import { render, staticRenderFns } from "./InnoIcon.vue?vue&type=template&id=14770fb2&"
import script from "./InnoIcon.vue?vue&type=script&lang=js&"
export * from "./InnoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports